import { FC } from 'react';
import { Link as RouterLink } from 'react-router';
import {
  ListItem,
  ListItemText,
  Skeleton,
  ListItemButton,
} from '@mui/material';

interface Props extends Specializations.Specialization {
  linkTo: string;
}

export const SpecializationRow: FC<Props> = ({ linkTo, ...specialization }) => {
  
  return (
    <ListItem
      disableGutters
      disablePadding
      divider
    >
      <ListItemButton
        alignItems="center"
        component={RouterLink}
        to={linkTo}
      >
        <ListItemText
          primary={specialization.title}
          slotProps={{
            primary: {
              noWrap: true,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export const SpecializationRowSkeleton: React.FC = () => {

  return (
    <ListItem disableGutters disablePadding divider>
      <ListItemButton disabled>
        <ListItemText
          primary={<Skeleton width="60%" sx={{ maxWidth: 280 }} />}
        />
      </ListItemButton>
    </ListItem>
  );
};
